/**
 * @owner @Appboy/core-objects
 */
import type { AllRouteEndpoints } from "../routeTypes";
export const appsCatalogs = "/apps/catalogs";
export const appsCatalogsCacheKeys: AllRouteEndpoints[] = ["/apps/catalogs"];
